type getLabelArgs = {
	label: string;
	firstSelectedLabel: string;
	numSelectedOptions: number;
};

export const getButtonText = ({
	label,
	firstSelectedLabel = '',
	numSelectedOptions,
}: getLabelArgs): string => {
	const colon = firstSelectedLabel && label ? ': ' : '';
	const comma = firstSelectedLabel && numSelectedOptions > 1 ? ',' : '';

	return `${label}${colon}${firstSelectedLabel}${comma}`;
};
